import { Spinner } from 'reactstrap';
import './UsageTransferMetricCard.css';

type MetricValueProps = {
  title: string
  value: string | number
  alignRight?: boolean
  isMoney?: boolean
  isLoading?: boolean
}
const UsageTransferMetricValue = ({
  title,
  value,
  isMoney = false,
  isLoading,
}: MetricValueProps) => {
  const numericValue =
    typeof value === 'number'
    ? value
    : !isNaN(Number(value))
    ? Number(value)
    : null;

  const displayValue =
  numericValue === null || numericValue === undefined
    ? '0.00'
    : isMoney && numericValue < 10000
      ? `${typeof numericValue === 'number'
          ? numericValue.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : numericValue}`
      : `${numericValue.toLocaleString()}`;

  return (
    <div className='metric-block '>
      <p className='metric-title'>{title}</p>
      <div className='metric-value'>
        {isLoading ? (
          <Spinner size='sm' color='primary' />
        ) : (
          <>
            {isMoney
              ? `$${displayValue}`
                : (
                  <>
                    {displayValue}
                    <span className="metric-unit"> items</span>
                   </>
               )
            }
          </>
        )}
      </div>
    </div>
  );
};
export default UsageTransferMetricValue;